import { render, staticRenderFns } from "./viewFaqs.vue?vue&type=template&id=19568f56"
import script from "./viewFaqs.vue?vue&type=script&lang=js"
export * from "./viewFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports